module.exports = __webpack_public_path__ + "img/w26-b2.3824de30.jpg";